export const EXSBOWNER_DELETE_RESET = 'EXSBOWNER_DELETE_RESET'
export const EXSBOWNER_DELETE_SET_ERROR = 'EXSBOWNER_DELETE_SET_ERROR'
export const EXSBOWNER_DELETE_SET_DELETED = 'EXSBOWNER_DELETE_SET_DELETED'
export const EXSBOWNER_DELETE_TOGGLE_LOADING = 'EXSBOWNER_DELETE_TOGGLE_LOADING'
